import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllTenant = (queryParams) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.tenants,
		method: "get",
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: queryParams,
	});
};

export const createTenant = (data) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.createTenant,
		method: "post",
		headers: {
			Authorization: `Bearer ${token}`,
		},
		data: data,
	});
};

export const updateTenant = (id, data) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.tenant(id),
		method: "put",
		headers: {
			Authorization: `Bearer ${token}`,
		},
		data: data,
	});
};

export const deleteTenant = (id) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.tenant(id),
		method: "delete",
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};
